import type { CatalogItem } from '@matix/types';
import { appQueryClient } from './queryClient';
import { useTenantConfig } from '../store/tenantConfig';

/**
 * The catalog row for an item, from the sync cache the till already holds
 * (`['catalog', 'sync']`) — or null when the catalog has not loaded or the
 * item is no longer in it. Never fetches.
 */
export function catalogItemById(id: number): CatalogItem | null {
  const sync = appQueryClient.getQueryData<{ changed_items?: CatalogItem[] }>(['catalog', 'sync']);
  return sync?.changed_items?.find((it) => it.id === id) ?? null;
}

/**
 * What a cart line's product carries when it was rung up from the CATALOG and
 * a reloaded invoice line does not — so an edited invoice's cart is the same
 * as a new sale's (the user, 2026-10-01): the item code, the barcode of the
 * line's unit (the catalog's own rule), the photo when the tenant shows them,
 * decimal quantities, and the restock-on-return flag.
 */
export function catalogProductExtras(
  itemId: number,
  unitId: number | null,
): {
  code?: string | null;
  barcode?: string | null;
  image?: string | null;
  allowDecimals?: boolean;
  restockOnReturn?: boolean;
} {
  const item = catalogItemById(itemId);
  if (!item) return {};
  const unit = unitId != null ? item.units.find((u) => u.unit_id === unitId) : null;
  const selling = item.units.find((u) => u.unit_id === item.selling_unit_id);
  const barcode = unit?.barcode ?? selling?.barcode ?? item.units.find((u) => u.barcode)?.barcode ?? item.barcodes?.[0] ?? null;
  return {
    code: item.code ?? null,
    barcode,
    image: useTenantConfig.getState().showProductImages ? item.image_data ?? null : null,
    allowDecimals: item.allow_decimals,
    restockOnReturn: item.restock_on_return,
  };
}
